import React from 'react';
import { string } from 'prop-types';
import Text from '../Text';

const Quote = ({
  children
}) => /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement("blockquote", null, children));

Quote.propTypes = {
  children: string.isRequired
};
export default Quote;